/** Recuperado del despliegue 2026-10-05. Conserva lógica y memoización originales. */
import {
  rec_DialogoConfirmacion as DialogoConfirmacion,
  rec_JSXRuntime as JSXRuntime,
  rec_Po as Po,
  rec_React as React,
  rec_ReactCompiler as ReactCompiler,
} from "../../runtime/index.jsx";
export function ProveedorDialogos(e) {
  let t = (0, ReactCompiler.c)(8),
    { children: n } = e,
    [r, i] = (0, React.useState)(null),
    a = (0, React.useRef)(null),
    o;
  t[0] === Symbol.for(`react.memo_cache_sentinel`)
    ? ((o = (e) =>
        new Promise((t) => {
          ((a.current = t), i(e));
        })),
      (t[0] = o))
    : (o = t[0]);
  let s = o,
    c;
  t[1] === Symbol.for(`react.memo_cache_sentinel`)
    ? ((c = (e) => {
        (i(null), a.current?.(e), (a.current = null));
      }),
      (t[1] = c))
    : (c = t[1]);
  let l = c,
    u;
  t[2] === Symbol.for(`react.memo_cache_sentinel`)
    ? ((u = {
        confirmar: (e) =>
          s({
            tipo: `confirmar`,
            ...e,
          }),
        pedirTexto: (e) =>
          s({
            tipo: `texto`,
            ...e,
          }),
      }),
      (t[2] = u))
    : (u = t[2]);
  let f = u,
    p;
  t[3] === r
    ? (p = t[4])
    : ((p = r && <DialogoConfirmacion dialogo={r} onCerrar={l} />),
      (t[3] = r),
      (t[4] = p));
  let m;
  return (
    t[5] !== n || t[6] !== p
      ? ((m = <Po.Provider value={f} children={[n, p]} />),
        (t[5] = n),
        (t[6] = p),
        (t[7] = m))
      : (m = t[7]),
    m
  );
}
